import React, { useState, useEffect } from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead,
    TableBody,TableContainer,
      Paper,
    TableCell, Card, Box, Typography,
} from "@material-ui/core";
import SuperActivityService from "./Locality/Service/superActivityService"
import axios from 'axios';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SubActivityService from "./Locality/Service/subActivityService";
import ActivityTabelService from "./Locality/Service/activityTabelService";
import * as Yup from 'yup';
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import { styled } from '@material-ui/styles';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AddClassService from "./Locality/Service/addClassService";
import { canEditDeleteActivityRow } from "../../utils/activityRowPermissions";
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function SubActivity() {
    const tableHeaders = ['Class', 'Area Of Work', 'List Of Activities', 'Exercise', 'Edit', 'Delete'];
    const classes = useStyles();
    const [filterActivity, setfilterActivity] = useState('');
    const [filterExercise, setExercise] = useState('');
    const [filterExerciseList, setExerciseList] = useState([]);
    const [subActivitylList, setSubActivityList] = useState([]);
    const [temSubActivitylList, setTempSubActivityList] = useState([]);
    const [activityList, setActivityList] = useState([]);
    const [addActivityList, setAddActivityList] = useState([]);
    
    const [addActivityLists, setAddActivityLists] = useState([]);

    const [subActivityIdList, setSubActivityIdList] = useState([]);
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');
    const [open, setOpen] = React.useState(false);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [pendingDelete, setPendingDelete] = useState(null);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const [addClassList, setAddClassList] = useState([]);
    var [classId, setClassId] = useState("");
    const [subActivity, setSubActivity] = useState({
        classId: '',
        superActivityId: '',
        activityId: '',

        subActivityName: '',
        upload: '',
    });
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }
    const validationSchema = Yup.object().shape({
        // classId: Yup.string().required('Class Name is required'),
        subActivityName: Yup.string(),
        upload: Yup.string(),
    });
    useEffect(() => {
        getSubList();
        getActivityList()
        getAddClassList();
        return () => {
            setSubActivityIdList([]);
            setActivityList([]);
            setSubActivityList([]);
            setTempSubActivityList([]);
            setAddSuperActivityList([]);
        }
    }, []);
    const handleOpen = (status) => {
        if (status) {
            setSubActivity({
                subActivityName: '',
            })
        }

        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const activityIdOf = (act) => {
        const a = act.activityId;
        if (!a) return "";
        return a._id != null ? a._id : a;
    };

    useEffect(() => {
        const list = Array.isArray(temSubActivitylList) ? temSubActivitylList : [];
        let scoped = list;
        if (classId) {
            const idStr = String(classId);
            scoped = list.filter((act) => {
                const cid = act.classId && (act.classId._id != null ? act.classId._id : act.classId);
                return cid != null && String(cid) === idStr;
            });
        }
        if (filterActivity) {
            const fa = String(filterActivity);
            scoped = scoped.filter((act) => String(activityIdOf(act)) === fa);
        }
        setExerciseList(
            scoped.map((result) => ({ name: result.subActivityName, value: result._id }))
        );
        let displayRows = scoped;
        if (filterExercise) {
            const fe = String(filterExercise);
            displayRows = scoped.filter((act) => String(act._id) === fe);
        }
        setSubActivityList(displayRows);
    }, [classId, temSubActivitylList, filterActivity, filterExercise]);

    const getSubList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        SubActivityService.getAllSubActivity(userDetails.schooleId).then((res) => {

            if (res) {
                const rows = Array.isArray(res) ? res : [];
                setTempSubActivityList(rows);
            }

        }).catch((err) => {

        });
    }
    const getActivityList = (event, obj) => {
        
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsubActList = {
            schooleId: userDetails.schooleId,
            classId: formik.values.classId,
            superActivityId: event ? event.target.value : formik.values.superActivityId
        };


        ActivityTabelService.getAllActivityTabeBySuperActivityId(getsubActList).then((res) => {
            setAddActivityList(res);
            if (obj) {
                setSubActivity(obj);
            }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const getActivityLists = (event) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        const schoolIdRaw =
            userDetails.schooleId?._id || userDetails.schooleId || userDetails.schoolId?._id || userDetails.schoolId;
        const getsubActLists = {
            classId: event.target.value,
        };
        if (userDetails.role !== "SUPERADMIN" && schoolIdRaw) {
            getsubActLists.schooleId = schoolIdRaw;
        }

        ActivityTabelService.getAllActivityTabeBySuperActivityId(getsubActLists).then((res) => {
            setAddActivityLists(Array.isArray(res) ? res : []);
        }).catch((err) => {
            setAddActivityLists([]);
        });
    }
    // const getAddClassList = () => {
    //     const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //     AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
    //         setAddClassList(res);
    //     }).catch((err) => {
    //         // setError(err.message);
    //     });
    // }
    const getAddClassList = (event) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            if (userDetails.role === "TEACHER") {
                res = res.filter(res => res._id === userDetails.classId);
            }
            setAddClassList(res);
            if (userDetails.classId) {
                setClassId(userDetails.classId);
                // filterActivitys({ target: { value: userDetails.classId } });
              } else {
                setClassId(""); // No default selection
              }
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const editSubActivity = (sub) => {
        const obj = JSON.parse(JSON.stringify(sub));
        obj.superActivityId = sub.superActivityId ? sub.superActivityId._id : '';
        obj.activityId = sub.activityId ? sub.activityId._id : '';
        // obj.superActivityId = sub.superActivityId ? sub.superActivityId._id : '';
        // obj.activityId = sub.activityId ? sub.activityId._id : '';
        obj.classId = sub.classId ? sub.classId._id : '';

        // tabel.classId = activity.classId ? activity.classId._id :'';
        // getActivityList(obj)
        getSuperActivityList({ target: { value: obj.classId } });
        getActivityList({ target: { value: obj.superActivityId } })

        setSubActivity(obj)
        handleOpen(false)
    }
    const deleteSubActivity = (subdelete) => {
        if (!subdelete) return;
        setPendingDelete(subdelete);
        setDeleteConfirmOpen(true);
    };
    const confirmDelete = async () => {
        const row = pendingDelete;
        setDeleteConfirmOpen(false);
        setPendingDelete(null);
        if (!row) return;
        try {
            await SubActivityService.deleteSubActivity(row);
            getSubActivityList();
        } catch {
            // ignore
        }
    };
    const getSubActivityList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        SubActivityService.getAllSubActivity(userDetails.schooleId).then((res) => {
            const rows = Array.isArray(res) ? res : [];
            setTempSubActivityList(rows);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const formik = useFormik({
        initialValues: subActivity,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem("userDetail"));
            values.schooleId = userDetails.schooleId;
            if (subActivity._id) {

                SubActivityService.upadeSubActivity(values).then((res) => {

                    handleClose();
                    getSubActivityList();
                    resetForm()
                    alert("Sub Activity Tabel Updated Successfully.");
                }).catch((err) => {
                });
            }
            else {
                SubActivityService.creteSubActivity(values).then((res) => {
                    getSubActivityList();
                    resetForm();
                    handleClose();
                    alert(" Sub Activity Tabel Added Successfully.");
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {
                        alert(err.response.data.message)
                    })
            }

        },
    });
    const getSuperActivityList = (event, obj) => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const getsupActList = { classId: event.target.value };

        SuperActivityService.getAllSuperActivityById(userDetails.schooleId, getsupActList).then((res) => {

            setAddSuperActivityList(res);
        }).catch((err) => {
            // setError(err.message);
        });
    }
    const filterActivitys = (event) => {
        const iampig = event && event._id != null ? event._id : "";
        setfilterActivity(iampig);
    }
    
    // const filterExcDetails = (event) => {
    //     const extId = event?event._id:'';
    //         setExercise(extId);
    //         if (extId) {
    //             const filterValue = temActivitylList.filter(act => act._id === extId);
    //             setTabelList(filterValue);
    //         } else {
    //             setTabelList(temActivitylList);
    //         }

    //     }
    const handleFileChange = (e) => {
        setFile(e.target.files[0]); // Get the selected file
    };


    const handleFileUpload = async () => {
        if (!file) {
            setMessage('Please select a file first.');
            return;
        }

        const formData = new FormData();
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        formData.append('excel', file); // Attach the file to the FormData object
        formData.append('schooleId', userDetails.schooleId);

        try {
            SubActivityService.uploadBulkRecords('/subactivity/data/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data', // Let Axios handle the boundary
                },
            }).then((res) => {
                alert("Data Imported Successfully.")
                getSubActivityList();
            }).catch((err) => {
                // setError(err.message);
                alert("Failed to upload check file format.")
            });


        } catch (error) {
            console.error('Error uploading file:', error);
            setMessage('Failed to upload file.');
        }
    };
    const filterExcDetails = (event) => {
        const sub = event ? event.value : "";
        setExercise(sub);
    }
    return (
        <>
            <PageTitle title="Exercise"
                button={<Button
                    variant="contained" onClick={() => handleOpen(true)}
                    size="medium"
                    color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Exercise
                </Button>
                }

            />
            <Box style={{ marginBottom: 16, marginTop: 8, padding: 12, backgroundColor: 'rgba(0,0,0,0.04)', borderRadius: 4 }}>
                <Typography variant="body2" color="textSecondary">
                    By default, all area of work, activities, and exercise are added. If you want to add extra activities, add them here.
                </Typography>
            </Box>
<Card sx={{ maxWidth: 345 }}>
<Box  style={{margin:"15px"}} >

            <Grid container spacing={2} columns={12} >

  <Grid item xs={6} sm={6} md={3}  >
                                    <FormControl className={classes.formControl} fullWidth="true"
                                    >
                                        <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            name="classId"
                                            label="selectClass"


                                            onChange={(e) => {
                                                const nextClassId = e.target.value;
                                                setClassId(nextClassId);
                                                setfilterActivity("");
                                                setExercise("");
                                                getActivityLists(e);
                                            }}
                                            value={classId}
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>

                                            {addClassList.map(({ _id, className }) => (
                                                <MenuItem key={_id} value={_id}>{className}

                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                </Grid>
                
                 
                <Grid item xs={3}>
               
                    <Autocomplete
                        key={classId || "no-class"}
                        id="combo-box-demo"
                        options={addActivityLists}
                        getOptionLabel={(option) => option.activityName}

                        onChange={(event, newValue) => {
                            filterActivitys(newValue);
                        }}
                        renderInput={(params) => <TextField {...params} label="Activities" variant="filled" />}
                    />
                </Grid>
                <Grid item xs={6}>


                    <input type="file" onChange={handleFileChange} />
                    <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }} onClick={handleFileUpload} >
                        Upload Excel
                    </Button>
                    <br></br>
                    <a
                        href="https://artistimages.blob.core.windows.net/montestory/Sample (1).xlsx" // Replace with your file URL
                        download="Sample.pdf" // Suggested name for the file
                    >
                        download Sample Formate
                    </a>
                    <br></br>
                    {message && <p>{message}</p>}


                    {/* <FormControl variant="filled" fullWidth="true" >
                            <InputLabel id="demo-simple-select-standard-label"> Activities</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="activityName"
                                name="activityId"
                                label="Activities"
                                value={filterActivity}
                                onChange={filterActivitys}
                            //  getClassNameList(e) 
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {addActivityList.map(({ _id, activityName }) => (
                                    <MenuItem key={_id} value={_id}>{activityName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl> */}

                </Grid>
                {/* <Grid item xs={6}> */}
                {/* <div > */}
                {/* <Autocomplete
      id="combo-box-demo"
      options={filterExerciseList}
      getOptionLabel={(option) => option.name}
      
      onChange={(event, newValue) => {
        filterExcDetails(newValue);
      }}
      renderInput={(params) => <TextField {...params} label="Exercise" variant="filled" />}
    /> */}
                {/* <FormControl variant="filled" fullWidth="true" >
                            <InputLabel id="demo-simple-select-standard-label"> Exercise</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="activityName"
                                name="activityId"
                                label=" Activities"
                                value={filterExercise}
                                onChange={filterExcDetails}
                            //  getClassNameList(e) 
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {filterExerciseList.map(({ value, name }) => (
                                    <MenuItem key={value} value={value}>{name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl> */}
                {/* </div> */}
                {/* </Grid> */}
                
            </Grid>

            </Box>
            </Card >
            <br></br>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>

                                                <TableContainer component={Paper} style={{ maxHeight: 500 }}>

                        <Table stickyHeader className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {subActivitylList.slice(pg * rpg, pg * rpg + rpg).map((sub) => (
                                    <TableRow key={sub._id}>
                                        <TableCell className="pl-3 fw-normal" >{sub.classId ? sub.classId.className : ''}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >
                                            {sub.activityId && sub.activityId.superActivityId
                                                ? (sub.activityId.superActivityId.superActivityName || '')
                                                : ''}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal" >{sub.activityId ? sub.activityId.activityName : ''}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{sub.subActivityName}</TableCell>
                                        <TableCell>
                                            {canEditDeleteActivityRow(sub) ? (
                                                <EditIcon style={{ cursor: 'pointer' }} onClick={() => editSubActivity(sub)} />
                                            ) : (
                                                <span title="System activities cannot be edited">
                                                    <EditIcon style={{ opacity: 0.35, cursor: 'not-allowed' }} />
                                                </span>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {canEditDeleteActivityRow(sub) ? (
                                                <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteSubActivity(sub)} />
                                            ) : (
                                                <span title="System activities cannot be deleted">
                                                    <DeleteIcon style={{ opacity: 0.35, cursor: 'not-allowed' }} />
                                                </span>
                                            )}
                                        </TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[1000, 10000, 100000]}
                            count={subActivitylList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add Activity</DialogTitle>
                <form onSubmit={formik.handleSubmit} >
                    <DialogContent style={{ width: 308 }}>
                        <FormControl className={classes.formControl} fullWidth="true"
                        >
                            <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="classId"
                                label="selectClass"
                                value={formik.values.classId}
                                onChange={e => { formik.handleChange(e); getSuperActivityList(e) }}

                                // onChange={formik.handleChange}
                                error={formik.touched.classId && Boolean(formik.errors.classId)}
                                helperText={formik.touched.classId && formik.errors.classId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>

                                {addClassList.map(({ _id, className }) => (
                                    <MenuItem key={_id} value={_id}>{className}

                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="demo-simple-select-standard-label">Area Of Work</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="superActivityName"
                                label="Area Of Work "
                                name="superActivityId"
                                // onChange={formik.handleChange}
                                onChange={e => { formik.handleChange(e); getActivityList(e) }}
                                value={formik.values.superActivityId}
                                error={formik.touched.superActivityId && Boolean(formik.errors.superActivityId)}
                                helperText={formik.touched.superActivityId && formik.errors.superActivityId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {addSuperActivityList.map(({ _id, superActivityName }) => (

                                    <MenuItem key={_id} value={_id}>{superActivityName}
                                        {/* <Checkbox checked={formik.values.categoryId.indexOf(parent) > -1} /> */}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl variant="standard" fullWidth="true" >
                            <InputLabel id="demo-simple-select-standard-label">List Of Activities</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="activityName"
                                name="activityId"
                                label="List Of Activities"
                                value={formik.values.activityId}
                                onChange={e => {
                                    formik.handleChange(e);
                                    //  getAddClassList(e)
                                }}

                                // onChange={formik.handleChange}
                                //  getClassNameList(e) 
                                error={formik.touched.activityId && Boolean(formik.errors.activityId)}
                                helperText={formik.touched.activityId && formik.errors.activityId}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {addActivityList.map(({ _id, activityName }) => (
                                    <MenuItem key={_id} value={_id}>{activityName}
                                        {/* <Checkbox checked={formik.values.categoryId.indexOf(parent) > -1} /> */}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            InputProps={{ style: { width: 258 } }}
                            autoFocus
                            margin="dense"
                            id="subActivityName"
                            name="subActivityName"
                            label="Exercise"
                            type="text"
                            variant="standard"
                            value={formik.values.subActivityName}
                            onChange={formik.handleChange}
                            error={formik.touched.subActivityName && Boolean(formik.errors.subActivityName)}
                            helperText={formik.touched.subActivityName && formik.errors.subActivityName}
                        />
                        <br></br>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit">Add</Button>
                    </DialogActions>


                </form>
            </Dialog>

            <Dialog
                open={deleteConfirmOpen}
                onClose={() => {
                    setDeleteConfirmOpen(false);
                    setPendingDelete(null);
                }}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>localhost:3000 says</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2">
                        Are you sure you want to delete{" "}
                        <b>"{pendingDelete?.subActivityName ? String(pendingDelete.subActivityName) : "this exercise"}"</b>?
                        <br />
                        <br />
                        This action cannot be undone. All associated data will be permanently removed.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={confirmDelete}
                        style={{ backgroundColor: "rgb(15 59 98)", color: "white" }}
                        variant="contained"
                    >
                        OK
                    </Button>
                    <Button
                        onClick={() => {
                            setDeleteConfirmOpen(false);
                            setPendingDelete(null);
                        }}
                        style={{ backgroundColor: "#f3e5e5", color: "#0f3b62" }}
                        variant="contained"
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}


